import datacentral from '@/utils/axios/datacentral'
import type {
    ResponseArray,
    ResponseObject,
    ErrorResponse,
} from '@/types/shared'
import { DataGridPayload } from 'vnetwork-ui/dist/components/GokuDataGrid'
import type {
    Role,
    RoleCreatePayload,
    RoleUpdatePayload,
    RolePermissions,
    ResourceScope,
} from '../types'
import qs from 'query-string'

export const getRoles = async (payload: DataGridPayload) => {
    const response = await datacentral.get<ResponseArray<Role>>(
        `/iam/roles?${qs.stringify(payload)}`
    )
    return response?.data
}

export const getRole = async (
    roleId: string
): Promise<ResponseObject<Role> | ErrorResponse> => {
    const response = await datacentral.get(`/iam/roles/${roleId}`)
    return response?.data
}

export const getRolePermissions = async (
    roleName: string
): Promise<RolePermissions> => {
    const response = await datacentral.get<RolePermissions>(
        `/iam/roles/${roleName}/permissions`
    )
    return response?.data
}

export const getResourcesScopes = async (): Promise<
    ResponseArray<ResourceScope> | ErrorResponse
> => {
    const response = await datacentral.get<ResponseArray<ResourceScope>>(
        '/iam/resources-scopes'
    )
    return response?.data
}

export const createRole = async (
    payload: RoleCreatePayload
): Promise<ResponseObject<Role> | ErrorResponse> => {
    const response = await datacentral.post('/iam/roles', payload)
    return response?.data
}

export const updateRole = async (
    roleName: string,
    payload: RoleUpdatePayload
): Promise<ResponseObject<Role> | ErrorResponse> => {
    const response = await datacentral.put(`/iam/roles/${roleName}`, payload)
    return response?.data
}

export const deleteRole = async (
    roleName: string
): Promise<ResponseObject<{ role: string }> | ErrorResponse> => {
    const response = await datacentral.delete(`/iam/roles/${roleName}`)
    return response?.data
}
